<template>
            <div  class="ps-widget__content">
                  <ul v-if="language_.language=='English'">
                    <li v-bind:class="[priv_state_]" v-if="caller_role!='Basic'" ><a href="/#/private"><i class="icon-user"></i>User management</a></li>
                    <li v-bind:class="[userde_state_]"><a href="/#/Userdetails"><i class="icon-user"></i>User account</a></li>
                    <li v-bind:class="[invi_state_]" v-if="caller_role!='Basic'" ><a href="/#/invitations"><i class="icon-alarm-ringing"></i> Invitations</a></li>
                    <li><a href="/#/products"><i class="icon-store"></i>Products</a></li>
                    <li v-bind:class="[recip_state_]"><a href="/#/recipients"><i class="icon-users"></i>Recipients</a></li>
                    <li><a href="/#/login"><i class="icon-power-switch"></i>Logout</a></li>
                  </ul>

                  <ul v-if="language_.language=='Français'">
                    <li v-bind:class="[priv_state_]" v-if="caller_role!='Basic'" ><a href="/#/private"><i class="icon-user"></i>Gestion des utilisateurs</a></li>
                    <li v-bind:class="[userde_state_]"><a href="/#/Userdetails"><i class="icon-user"></i>Mon compte</a></li>
                    <li v-bind:class="[invi_state_]" v-if="caller_role!='Basic'" ><a href="/#/invitations"><i class="icon-alarm-ringing"></i> Mes Invitations</a></li>
                    <li><a href="/#/products"><i class="icon-store"></i>Produits</a></li>
                    <li v-bind:class="[recip_state_]"><a href="/#/recipients"><i class="icon-users"></i>Destinataires</a></li>
                    <li><a href="/#/login"><i class="icon-power-switch"></i>Déconnexion</a></li>
                  </ul>
            </div>

            
</template>



<script>
export default {
  name: 'SideMenu',
  props: ['lang','invi_state','priv_state','recip_state','userde_state'],
  data () {
    
    return {
      msg:'Welcome to Your Vue.js App',
      caller_role:localStorage.getItem('caller_role'),
      languages:[{id:1,language:"English", href:"./assets/img/flag/en.png"},{id:2,language:"Français", href:"./assets/img/flag/fr.png"}],
      language_:{id:1,language:"English", href:"./assets/img/flag/en.png"},
      language: this.lang,
      invi_state_:this.invi_state,
      priv_state_:this.priv_state,
      recip_state_:this.recip_state,
      userde_state_:this.userde_state,
    }
  },


    watch: {

      lang:function(){
        this.language_ = this.lang;
        console.log("printing language changing event!");
        //this.language = this.lang ;
      }
    },


    mounted(){

      console.log("printing language value in sideMenu component :");
      console.log(this.oooo);

       if(localStorage.getItem('lang')=='en'){
         this.language_ = this.languages[0];
       }else if(localStorage.getItem('lang')=='fr'){
         this.language_ = this.languages[1];
       }else{
         this.language_ = this.languages[0];
       }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SideMenu.vue